import React from "react";
import "./styles/WelcomeMsg.css"

export default function WelcomeMsg() {
    return (
        <div className="welcome">
            <h3>We're busy collecting all the wood to get the fire going, but we hope to have it crackling soon!</h3>
        </div>
    )
}